import { render, staticRenderFns } from "./DrawOnVideo.vue?vue&type=template&id=4e968e6b&scoped=true"
import script from "./DrawOnVideo.vue?vue&type=script&lang=js"
export * from "./DrawOnVideo.vue?vue&type=script&lang=js"
import style0 from "./DrawOnVideo.vue?vue&type=style&index=0&id=4e968e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e968e6b",
  null
  
)

export default component.exports